import { faBuildingColumns, faGaugeHigh, faGraduationCap, faIdCard, faRightFromBracket, faUser } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import { useMenuStorage } from '../../../storage/menu'
import { useNavigate } from 'react-router-dom';
import './style.css'
import { useUserStorage } from '../../../storage/user';

export default function MenuPainel() {

    const navigate = useNavigate();
    const { setSelectedMenu } = useMenuStorage(state => state.dispatch)
    const { selectedMenu } = useMenuStorage(state => state.dados)
    const tipoUSer = useUserStorage(state => state.tipoUSer)

    const Logout = () => {
        localStorage.removeItem("token");
        localStorage.removeItem("user");
        localStorage.removeItem("tipo");
        navigate("/");
    }


    return (
        <div className='divMenuOptions'>
            <Options onClick={() => { setSelectedMenu('Painel') }} icon={faGaugeHigh} title='Painel' selectedMenu={selectedMenu} />
            {
                localStorage.getItem("tipo") === 'ALUNO' || localStorage.getItem("tipo") === 'ESTUDANTE' && <Options onClick={() => { setSelectedMenu('Meu perfil') }} icon={faUser} title='Meu perfil' selectedMenu={selectedMenu} />
            }
            {localStorage.getItem("tipo")  !== "ADMINISTRADOR" && <> 
            {/* mudei regra, cursos matriculados agora é curso para entrar na regra de so aparecer o que cadastrou */}
                {/* <Options onClick={() => { setSelectedMenu('Cursos') }} icon={faBuildingColumns} title='Cursos' selectedMenu={selectedMenu} /> */}
                <Options onClick={() => { setSelectedMenu('Cursos Matriculados') }} icon={faGraduationCap} title='Cursos' selectedMenu={selectedMenu} />
            </>
            }
            {/* {
                tipoUSer === "ALUNO" && 
            } */}
            {(localStorage.getItem("temCarteira") == 'true') && <Options onClick={() => { navigate("/carteiraVisualizar") /* setSelectedMenu('Carteirinha') */ }} icon={faIdCard} title='Carteirinha' selectedMenu={selectedMenu} />}

            <hr color='#ddd'></hr>
            <Options onClick={Logout} icon={faRightFromBracket} title='Sair' selectedMenu={selectedMenu} />
        </div>
    )
}


function Options({ title, icon, onClick, selectedMenu }) {
    return (
        <div style={{ width: '280px' }}>
            {
                selectedMenu === title ?
                    <div className='painelButtonShow' onClick={onClick} style={{ display: 'flex', margin: '5px 0', height: '40px', alignItems: 'center', padding: '0 20px', borderRadius: '4px 0 0 4px' }}>
                        <FontAwesomeIcon style={{ marginRight: '10px' }} color='#fff' icon={icon} size='xl' />
                        <h4 style={{ color: '#fff' }}>{title}</h4>
                    </div>
                    :
                    <div className='painelButtonAwait' onClick={onClick} style={{ display: 'flex', margin: '5px 0', height: '40px', alignItems: 'center', padding: '0 20px', borderRadius: '4px 0 0 4px' }}>
                        <FontAwesomeIcon style={{ marginRight: '10px' }} color='#3e64de' icon={icon} size='xl' />
                        <h4 style={{ color: 'black' }}>{title}</h4>
                    </div>
            }

        </div>

    )
}

